module.exports = __webpack_public_path__ + "static/apple-icon-180x180-4f8c3bd258f7b72f4a1d8c4c8e11a5d9.png";